// extracted by css-extract-rspack-plugin
export default {"reactionsContainer":"Reactions-module__reactionsContainer__bVzf1","compactDensity":"Reactions-module__compactDensity__W5lB0"};